import { defineStore } from "pinia";
import { ref, Ref } from "vue";
import useClientStore from "@/store/clientStore.ts";
import { LedgerService } from "@/services";
import { IMainPageLedger } from "@/repositories/dto/ledger/IMainPageLedger.ts";

export const useMainPageStore = defineStore("main-page", () => {
  const ledgerService = new LedgerService();

  useClientStore(); // Initialize client store for side effects

  const currency: Ref<string> = ref("EUR");
  const currencyList: Ref<string[]> = ref(["EUR", "USD", "GBP"]);


  const cashBalance: Ref<string | null> = ref(null);
  const cryptoBalance: Ref<string | null> = ref(null);
  const totalBalance: Ref<string | null> = ref(null);

  const cashBalanceByCurrency: Ref<string[] | null> = ref(null);
  const cryptoPortfolioByCurrency: Ref<string[] | null> = ref(null);

  function _mapUserState(mainPage: IMainPageLedger | null): void {
    if (mainPage !== null) {
      cashBalance.value = mainPage.balances.cash.total + '';
      cryptoBalance.value = mainPage.balances.crypto.total + '';
      totalBalance.value = mainPage.balances.total.total + '';
    } else {
      cashBalance.value = null;
      cryptoBalance.value = null;
      totalBalance.value = null;
    }
  }

  async function getState() {
    try {
      const balances = await ledgerService.getBalances();
      await ledgerService.getAccounts();
      _mapUserState({
        balances,
      } as any as IMainPageLedger);

    } catch (e: any) {
      if (e.errorCode === "401") {

      } else {
        console.log("e:", e);
      }
    }
  }

  return {
    currency,
    currencyList,
    cashBalanceByCurrency,
    cashBalance,
    cryptoPortfolioByCurrency,

    getState,
  };
});

export default useMainPageStore;
